import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Eyebrow } from './Eyebrow';
import { CTAButton } from './CTAButton';
import { OFFER_ITEMS } from '../data/landing';
export function OfferSection() {
  return <section id="purchase" className="bg-cream-2 py-14 md:py-20" aria-labelledby="offer-title" data-id="element-113" data-mp="8n5cy8pxeon1">
      <div className="mx-auto max-w-[1080px] px-5" data-id="element-114" data-mp="dex0099vic8f">
        <div className="mx-auto max-w-[560px] text-center" data-id="element-115" data-mp="idi2yggifa0k">
          <Eyebrow data-id="element-116" data-mp="icym732liro4">La oferta</Eyebrow>
          <h2 id="offer-title" className="mt-4 text-[26px] leading-[1.15] sm:text-[34px] lg:text-[38px]" data-id="element-117" data-mp="mejusc83kjsi">
            Todo lo que recibes
          </h2>
        </div>

        <div className="mx-auto mt-8 max-w-[420px] rounded-[14px] border border-line bg-cream-soft p-5 md:p-6" data-id="element-118" data-mp="wcr7givcsfop">
          <ul className="divide-y divide-line/70" data-id="element-119" data-mp="2t62siks2mk88">
            {OFFER_ITEMS.map(item => <li key={item.label} className="flex items-start justify-between gap-3 py-2.5" data-id="element-120" data-mp="2y3uk1dot04bw">
                <span className="flex items-start gap-2 text-[12px] font-medium text-ink md:text-[13px]" data-id="element-121" data-mp="12otf1flef9hy">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 flex-none text-gold" aria-hidden="true" data-id="element-122" data-mp="xvh0jyafoj2x" />
                  {item.label}
                </span>
                <span className="flex-none text-[11px] font-bold text-ink-muted" data-id="element-123" data-mp="ouaj9mzyn48m">
                  {item.value}
                </span>
              </li>)}
          </ul>

          <div className="mt-5 rounded-[12px] bg-cream-2 px-4 py-5 text-center" data-id="element-124" data-mp="1go2ta9q1ntja">
            <p className="text-[12px] font-medium text-ink-muted line-through" data-id="element-125" data-mp="1ckdc45bp8e8a">
              US$49
            </p>
            <p className="mt-0.5 text-[34px] font-extrabold leading-none tracking-[-0.03em] text-ink md:text-[40px]" data-id="element-126" data-mp="17mbrvh2je8v8">
              US$19
            </p>
            <p className="mt-2 text-[9px] font-bold uppercase tracking-[0.14em] text-ink-muted" data-id="element-127" data-mp="3scknh7h5md0d">
              Pago único · Acceso de por vida
            </p>
          </div>

          <div className="mt-5" data-id="element-128" data-mp="2noj9qmsi9mb">
            <CTAButton label="Quiero generar más atracción" data-id="element-129" data-mp="2mn9dphift66" />
          </div>
          <p className="mt-3 text-center text-[10px] font-medium text-ink-muted" data-id="element-130" data-mp="3ktl1qv6809du">
            Garantía de 7 días · Pago seguro · Acceso inmediato
          </p>
        </div>
      </div>
    </section>;
}